export const LOGIN_ILLUSTRATION_TITLE1 = "Automate to Elevate:";
export const LOGIN_ILLUSTRATION_TITLE2 = "Transforming Healthcare";
export const LOGIN_ILLUSTRATION_SUB_TITLE =
  "CPT © 2023 American Medical Association. All rights reserved.";
export const LOGIN_SIGN_IN_SUB_TITLE = "to access your account";
export const FORGOT_PASSWORD_SUB_TITLE =
  "Enter your user account's verified email address and we will send you a password reset link.";
export const FORGOT_PASSWORD_USERNAME_PLACEHOLDER = "Enter your username";
export const RESET_PASSWORD_LINK =
  "Enter your account's username, and we will send you a link to reset your password.";
export const FORGOT_PASSWORD_ILLUSTRATION_TITLE =
  "Enhance Your Account Security";
export const FORGOT_PASSWORD_ILLUSTRATION_SUB_TITLE =
  "For better account protection, enable two-factor authentication (2FA) with an authenticator app to safeguard your information and prevent unauthorized access.";
export const RESET_PASSWORD_TITLE = "Reset Password";
export const RESET_PASSWORD_SUB_TITLE = "Please choose a new password";
export const RESET_PASSWORD_SUCCESSFULL =
  "Your Password has been changed Successfully";
